var CartCoreCms = /** @class */ (function () {
    function CartCoreCms() {
    }
    return CartCoreCms;
}());
export { CartCoreCms };
//# sourceMappingURL=Cart.container.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/Cart/Cart.container.cms.js
// module id = 2392
// module chunks = 8